import { Space, Image } from "antd";
import CustomButton from "../../../../components/CustomButton/Button";
import DangerButton from "../../../../components/CustomButton/DangerButton";
import { formatDateTime } from "../../../../helpers/helpers";
import { safeIdSort, safeStringSort, safeNumberSort } from "../../../../helpers/sortHelpers";
import { BTN_TXT, GLOBAL_CONSTANTS } from "../../../../constants/constants";
import EyeIcon from "../../../../assets/icons/eye-icon.svg";

export const getRmColumns = ({ onView, onDeactivate } = {}) => [
  {
    title: "RM ID",
    dataIndex: "userId",
    key: "userId",
    width: 150,
    sorter: (a, b) => safeIdSort(a?.userId, b?.userId),
  },
  {
    title: "RM Name",
    dataIndex: "userName",
    key: "userName",
    width: 250,
    sorter: (a, b) => safeStringSort(a?.userName, b?.userName),
  },
  {
    title: "RM Location",
    dataIndex: "rmCityName",
    key: "rmCityName",
    width: 250,
    sorter: (a, b) => safeStringSort(a?.rmCityName, b?.rmCityName),
  },
  {
    title: "Customers Assigned",
    dataIndex: "usersAssigned",
    key: "usersAssigned",
    width: 250,
    sorter: (a, b) => safeNumberSort(a?.usersAssigned, b?.usersAssigned),
  },
  {
    title: "Created Date",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 200,
    render: (value) => (value ? formatDateTime(value) : GLOBAL_CONSTANTS.NA),
  },
  {
    title: "Actions",
    key: "actions",
    fixed: "right",
    render: (_, record) => {
      return (
        <Space size="small">
          <CustomButton
            type="text"
            icon={<Image src={EyeIcon} alt="View" preview={false} />}
            onClick={() => onView?.(record)}
          />

          <DangerButton
            variant="outlined"
            onClick={() => onDeactivate?.(record)}
          >
            {BTN_TXT.DEACTIVATE}
          </DangerButton>
        </Space>
      );
    },
  },
];
